module.exports = __webpack_public_path__ + "static/Site-2-dd340d49ca818fd5ff38aa916ce101e7.jpg";